import React from "react";
import "../../styles/Shared/Shared.css";
import "../../styles/Expense_Tracker/Styles_Transaction_Form.css";

class Transaction_Form extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            transaction_name: props.Transaction ? props.Transaction.transaction_name : "",
            transaction_amount: props.Transaction ? props.Transaction.transaction_amount : "",
            validation_err: "",
            button_name: props.button_name,
            form_name: props.form_name
        }
    }

    onTransactionNameChanged = (event) => {
        let name = event.target.value;
        this.setState((prevState) => {
            return {
                transaction_name: name
            }
        });
    };

    onTransactionAmountChanged = (event) => {
        let amount = event.target.value;
        this.setState((prevState) => {
           return {
               transaction_amount: amount
           }
        });
    };

    onTransactionSubmit = (event) => {
        event.preventDefault();
        if (this.state.transaction_name === "") {
            this.setState((prevState) => {
                return {
                    validation_err: "Transaction name is missing."
                }
            });
        } else if (this.state.transaction_amount === "") {
            this.setState((prevState) => {
               return {
                   validation_err: "Transaction amount is missing."
               }
            });
        } else {
            this.setState((prevState) => {
               return {
                   validation_err: ""
               }
            });
            this.props.onSubmit({
                transaction_name: this.state.transaction_name,
                transaction_amount: this.state.transaction_amount,
            });
        }
    };

    render() {
        return (
            <div className="add_expenses_container">
                <div className="validation_error">
                    <p>
                        {this.state.validation_err}
                    </p>
                </div>
                <div className="add_expenses_main">
                    <p className="title">{this.state.form_name}</p>
                    <hr/>
                    <form onSubmit={this.onTransactionSubmit} className="add_expense_input_field_collection">
                        <div className="form-group expense_name">
                            <p className="title">Expense Name</p>
                            <input
                                className="form-control"
                                type="text"
                                name="expense_name"
                                required={true}
                                placeholder="Enter expense name ..."
                                value={this.state.transaction_name}
                                onChange={this.onTransactionNameChanged}
                            />
                        </div>

                        <div className="form-group expense_amount">
                            <p className="title">Amount</p>
                            <p>(Negative-Expense, Positive-Income)</p>
                            <input
                                className="form-control"
                                type="text"
                                name="expense_amount"
                                required={true}
                                placeholder="Enter amount ..."
                                value={this.state.transaction_amount}
                                onChange={this.onTransactionAmountChanged}
                            />
                        </div>
                        <button>{this.state.button_name}</button>
                    </form>
                </div>
            </div>
        );
    }
}

export default Transaction_Form;